import { BUSCAR_ENCOMENDA_AVULSA, LIMPAR_ENCOMENDA_AVULSA } from '../../actions/types'

const initial = null

export default function reducerEncomendaAvulsa (state = initial, action = {}) {
  switch (action.type) {
    case BUSCAR_ENCOMENDA_AVULSA: {
      return action.payload
    }

    case LIMPAR_ENCOMENDA_AVULSA: {
      return initial
    }

    default:
      return state
  }
}
